<!-- 2022.11 宮ヶ瀬オンデマンドサービス終了後の表示 -->
<template>
  <div class="demand-list">
    <a></a>
    <a style="text-align: right">
      <img
        style="width: 5%; padding-right: 1%"
        :src="require(`@/assets/img/icon/png/info.png`)"
        class="romance-car"
      />運行について
    </a>
  </div>
  <button class="do-resv">（現在はご利用いただけません）</button>
</template>

<script>
export default {
  name: "TheDemandIndexOutOfService",
};
</script>
<style scoped lang="scss">
.do-resv {
  background: white;
  font-size: 1rem;
  padding: 15px 10px;
  width: 100%;
  border: none;
  text-align: left;
  color: black;
}

.demand-list {
  padding: 20px 10px 5px;
  background: #f9f9f9;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  display: flex;

  a {
    font-size: 0.7rem;
    color: #888888;
    width: 50%;
    font-weight: bold;
  }
}
</style>
